import knayi from 'knayi-myscript';
import Rabbit from 'rabbit-node';

const fontService = {
  convertToUni(zgtext) {
    // return knayi.fontConvert(zgtext, 'unicode');
    return Rabbit.zg2uni(zgtext);
  },

  convertToZg(unitext) {
    // return knayi.fontConvert(unitext, 'zawgyi');
    return Rabbit.uni2zg(unitext);
  },

  detect(txt) {
    return knayi.fontDetect(txt);
  }
};

export { fontService };